<template lang="pug">
    crud-form( :fields="fields" no-buttons ref='showForm' )
        template( slot='appendContent' )
            employee-contract-asset-discount( :contract='contractProp' )
</template>

<script>
/* components */
import { CrudForm } from '@/components/reusable_components'
import EmployeeContractFields from './fields/EmployeeContractFields'
import EmployeeContractAssetDiscount from './EmployeeContractAssetDiscount'
/* services */
import EmployeeService from '@/services/api/employee'
import ContractTypeService from '@/services/api/contractType'
import ContractPeriodService from '@/services/api/contractPeriod'
export default {
    name: 'employee-has-active-contract',
    props: {
        /**
         * 
         */
        contractProp: {
            type: Object,
            default: ()=>[],
        }
    },
    data: function(){
        return {
            fields: EmployeeContractFields,
        }
    },
    // computed: {},
    methods: {
        // -- UI Modification
        // -- Data fetching
        /**
         * 
         */
        async fetchAllEmployees(){
            return await EmployeeService.fetchAll()
        },
        /**
         * 
         */
        async setEmployees(){
            let arrEmployees = await this.fetchAllEmployees()
            this.fields[0].options.data = this.formatNameEmployee(arrEmployees)
        },
        /**
         * 
         */
        async fetchAllContractType(){
            return await ContractTypeService.fetchAll()
        },
        /**
         * 
         */
        async setContractType(){
            let arrContractType = await this.fetchAllContractType()
            this.fields[1].options.data = arrContractType.data
        },
        /**
         * 
         */
        async fetchAllContractPeriod(){
            return await ContractPeriodService.fetchAll()
        },
        /**
         * 
         */
        async setContractPeriod(){
            let arrContractPeriod = await this.fetchAllContractPeriod()
            this.fields[2].options.data = arrContractPeriod.data
        },
        // -- Data handling and transformations
        /** 
         * 
         */
        formatNameEmployee(arrEmployee){
            return arrEmployee.map(employee=>{
                let newEmployee = {...employee}
                newEmployee.nameComplete = `${employee.names} ${employee.last_name1} ${employee.last_name2}`
                return newEmployee
            })
        },
        /**
         * 
         */
        setStructureInsideForm(){
            //
            const contract = {...this.contractProp}
            if ( contract )
                this.setParamsStructureForm( contract )
        },
        /**
         * 
         */
        setParamsStructureForm(contract){
            console.log(contract,'Contract here')
            let setFields = [...this.fields]
            setFields[0].value = contract.hr_employee_id
            setFields[1].value = contract.hr_contract_type_id
            setFields[2].value = contract.hr_contract_period_id
            setFields[3].value = contract.weekly_hours
            setFields[4].value = contract.base_salary
            setFields[5].value = contract.collation
            setFields[6].value = contract.mobilization
            setFields[7].value = contract.init_date
            setFields[8].value = contract.end_date
            setFields[9].value = contract.vacations_since
            setFields[10].value = contract.vacations_progressive_days
            this.fields = [...setFields]
        },
        // -- Validations and Error handling
        // -- Other functions
        // -- Vuex mappings
    },
    watch: {
        contractProp(val){
            console.log('contractProp',val)
        }
    },
    components: {
        'crud-form':CrudForm,
        'employee-contract-asset-discount' :EmployeeContractAssetDiscount,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    async mounted () {
        await this.setEmployees()
        await this.setContractType()
        await this.setContractPeriod()
        this.setStructureInsideForm()
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
    .spanStatus{
        color :red;
        font-weight: bold;
        font-size:20px;
    }
</style>